export default __webpack_public_path__ + "static/media/151-keyword.d3a4bddf.png";